import styled from 'styled-components';

import UI from '#front-credpago';

import globals from '../globals';

export const Container = styled.div`
  width: 100%;
  max-width: calc(${globals.containerMaxWidth} + 40px);
  margin: 0 auto;
  align-self: center;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  margin: 100px 0px;
  padding: 20px;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm}, ${UI.globals.mediaqueries.md} {
    margin: 25px 0px 50px 0px;
  }
`;
export const WrapperQuestion = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const WrapperConfirmation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const AlertWrapper = styled.div`
  margin-top: 60px;
  display: flex;
  justify-content: center;
`;

export const WrapperRadios = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  //width: 500px;
  text-align: center;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    width: 320px;
    flex-wrap: wrap;
    justify-content: center;
  }

  @media ${UI.globals.mediaqueries.md} {
    width: 720px !important;
  }
`;

export const Question = styled.h3`
  font-size: 24px;
  color: ${globals.colors.darkBlue};
  font-family: ${globals.fonts.default};
  font-weight: 600;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm}, ${UI.globals.mediaqueries.md} {
    text-align: center;
  }
`;

export const WrapperTextArea = styled.div`
  width: 70%;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    margin-bottom: 20px;
    width: 100%;
  }
`;

export const Error = styled.span`
  color: ${globals.colors.danger};
  font-family: ${globals.fonts.default};
  font-size: 16px;
  font-weight: bold;
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 70px;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    margin-top: 30px;
    justify-content: space-between;
  }
`;

export const WrapperBtn = styled.div`
  width: 140px;
`;
